import { useLocale } from '@gov-nx/core/service';
import { useProfilROSContextInstance } from '@gov-nx/module/page';
import { CopyButton, Tile, Tiles } from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';

export const POListView = () => {
	const { POData, code } = useProfilROSContextInstance();
	const { t } = useLocale(code);

	if (!POData.length) return null;

	return (
		<section>
			<h2 className="text-headline-s! text-(--text-secondary)">
				{t('nadpis.pravnicka-osoba')}
			</h2>
			<Tiles marginTop="s">
				{POData.map((subject) => (
					<Tile
						key={subject.ico}
						name={subject.nazevSpolecnosti}
						headlineLink={true}
						to={pageRouteResolver('profil.ros.detail', {
							ico: subject.ico,
							agendaCode: subject.agenda?.kod,
						})}
						icon={{ name: 'chevron-right', type: 'components' }}>
						<div className="flex flex-col justify-start gap-(--spacing-m) [ sm:flex-row sm:items-center ]">
							{subject.ico ? (
								<div className="flex items-center gap-1">
									<span className="inline-block mr-1! text-(--text-tertiary)">
										{t('zaznam.ico')}:
									</span>
									<strong>{subject.ico}</strong>
									<CopyButton
										label={
											t('akce.kopirovat-cislo-dokladu') + ' ' + subject.ico
										}
										value={subject.ico}
									/>
								</div>
							) : null}

							{subject?.sidloSpolecnosti?.adresaText ? (
								<div className="flex items-center gap-1">
									<span className="inline-block mr-1! text-(--text-tertiary)">
										{t('zaznam.sidlo')}:
									</span>
									<strong>{subject?.sidloSpolecnosti?.adresaText}</strong>
								</div>
							) : null}
						</div>
					</Tile>
				))}
			</Tiles>
		</section>
	);
};
